import { BEVEL_CHIP_ON, BEVEL_INSET_WHITE, BEVEL_NAVY_FACE, BEVEL_WHITE_FACE } from "@majourneys/shared/ui";

/**
 * The women-only pages' furniture: the house pewter and navy, plus the pink
 * accent from the approved lab (women-only-lab, 2026-10-27). Pink belongs to
 * women-only pieces only, never to the rest of the site.
 */
export { WOMEN_INK, WOMEN_PINK, WOMEN_WASH } from "@majourneys/booking";

export const NAVY = "#110E39";
/** Body meta text: about 6:1 on white (CLAUDE.md, Web a11y). */
export const MUTED = "#5a5d77";
export const CONTROL_EDGE = "rgba(17,14,57,0.16)";

/** A filter chip at rest and chosen. Chosen chips cast no shadow; the fill says "on". */
export const CHIP_REST = { background: BEVEL_WHITE_FACE, color: NAVY, boxShadow: `${BEVEL_INSET_WHITE}, 0 0 0 1.5px ${CONTROL_EDGE}` };
export const CHIP_ON = { background: BEVEL_NAVY_FACE, color: "#fff", boxShadow: BEVEL_CHIP_ON };

export const CHIP_CLASS =
  "mj-press inline-flex min-h-[36px] shrink-0 items-center whitespace-nowrap rounded-full px-4 py-2 font-sans text-[13.5px] font-semibold";
